import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGooglePlay, faApple } from "@fortawesome/free-brands-svg-icons";
// import { Icon } from "@fortawesome/fontawesome-svg-core";

// interface Props {
//   icon:void;
// }
const getDate = new Date().getFullYear();

const Footer: React.FC = () => {
  const ColumnOne = [
    { name: "Website", cls: "header", link: "/" },
    { name: "About Us", cls: "", link: "/about" },
    { name: "Features", cls: "", link: "/about" },
    { name: "Benefits", cls: "", link: "/benefit" },
    { name: "Contact Us", cls: "", link: "/" },
  ];
  const ColumnTwo = [
    { name: "Contact", cls: "header", link: "" },
    { name: "(234) 909 040 9121", cls: "", link: "/" },
    { name: "Whatsapp", cls: "", link: "wa.link/5izqji" },
    { name: "Email", cls: "", link: "/" },
  ];
  const ColumnThree = [
    { name: "Social Media", cls: "header", link: "/" },
    { name: "Instagram", cls: "", link: "https://www.instagram.com/estateiq_ng/" },
    { name: "Facebook", cls: "", link: "https://www.facebook.com/Estateiq-108416158522886" },
    { name: "Twitter", cls: "", link: "https://twitter.com/estateiq_ng" },
  ];
  const ColumnFour = [
    {
      name: "21B, Olori Muyibat Oyefusi Street, Lekki Phase 1, Lagos, Nigeria.",
      cls: "lheight",
    },
  ];
  const ButtonItems = [
    {
      icon: <FontAwesomeIcon icon={faApple} />,
      text: "Get it on",
      subtext: "AppStore",
    },
    {
      icon: <FontAwesomeIcon icon={faGooglePlay} />,
      text: "Get it on",
      subtext: "Google Play",
    },
  ];
  return (
    <Wrapper>
      <Container>
        <TextRegion>
          <h2>Simpler & Intuitive by Design</h2>
          <p>
            With EstateIQ, estate managers & residents within gated communities
            can enjoy additional layers of convenience, strengthen their
            security framework and enhance communications.
          </p>
          <CTA>Download App</CTA>
        </TextRegion>
        <Row>
          <Column>
            {ColumnOne.map((item, i) => (
              <NavLink to={item.link} key={i} className={item.cls}>
                {item.name}
              </NavLink>
            ))}
          </Column>
          <Column>
            {ColumnTwo.map((item, i) => (
              <SocialLink target="_blank" href={item.link} key={i} className={item.cls}>
                {item.name}
              </SocialLink>
            ))}
          </Column>
          <Column>
            {ColumnThree.map((item, i) => (
              <SocialLink target="_blank" href={item.link} key={i} className={item.cls}>
                {item.name}
              </SocialLink>
            ))}
          </Column>
          <Column>
            {ColumnFour.map((item, i) => (
              <NavLink to="/" key={i} className={item.cls}>
                {item.name}
              </NavLink>
            ))}
            <Buttons>
              {ButtonItems.map((btn, i) => (
                <AppButton key={i}>
                  {btn.icon}
                  <div>
                    {btn.text} <br />
                    <p>{btn.subtext}</p>
                  </div>
                </AppButton>
              ))}
            </Buttons>
          </Column>
        </Row>
        <Copyright>
          Copyright (c) {getDate} Estate IQ - All rights reserved
        </Copyright>
      </Container>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.div`
  background-color: var(--mainBlack);
  width: 100%;
  padding-top: 100px;
  padding-bottom: 57px;

  @media (max-width: 991px) {
    padding-top: 47px;
    padding-bottom: 100px;
  }
`;
const Container = styled.div`
  @media (max-width: 1336px) {
    width: 1000px;
    margin: auto;
  }
  @media (max-width: 1100px) {
    width: 100%;
  }
  @media (min-width: 1336px) {
    width: 1336px;
    margin: auto;
  }
`;
const TextRegion = styled.div`
  width: 740px;
  margin: auto;
  text-align: center;
  h2 {
    font-weight: 700;
    font-size: 51px;
    margin-bottom: 12px;
    color: white;
  }
  p {
    color: white;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 36px;
  }
  @media (max-width: 991px) {
    width: 550px;
    h2 {
      font-size: 36px;
    }
  }
  @media (max-width: 576px) {
    width: 98%;
    margin: auto;
    h2 {
      font-size: 24px;
      font-weight: 700;
    }
    p {
      font-size: 14px;
      line-height: 30px;
    }
  }
`;
const CTA = styled.button`
  padding: 12px 36px;
  border-radius: 6px;
  border: transparent;
  outline: 0;
  color: white;
  background-color: var(--mainBlue);
  margin-bottom: 120px;
  @media (max-width: 991px) {
    margin-bottom: 57px;
  }
`;
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 1100px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;
const Column = styled.div`
  width: 22%;
  text-align: left;
  display: flex;
  flex-direction: column;
  .header {
    color: #999999;
    // color:var(--mainYellow);
  }
  .lheight {
    line-height: 28px;
  }
  :last-child {
    width: 34%;
  }
  @media (max-width: 1100px) {
    width: 50%;
  }
  @media (max-width: 576px) {
    :nth-child(2n + 1) {
      width: 30%;
    }
    :nth-child(2n) {
      width: 70%;
    }
  }
`;
const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  padding-top: 18px;
  padding-bottom: 18px;
  font-size: 16px;
  @media (max-width: 576px) {
    font-size: 14px;
  }
`;
const SocialLink = styled.a`
  color: white;
  text-decoration: none;
  padding-top: 18px;
  padding-bottom: 18px;
  font-size: 16px;
  @media (max-width: 576px) {
    font-size: 14px;
  }
`;

const Copyright = styled.div`
  color: #999999;
  font-size: 12px;
  text-align: left;
  padding-top: 96px;
`;
const Buttons = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-top: 24px;
`;
const AppButton = styled.button`
  display: flex;
  align-items: center;
  background-color: #2e2e2e;
  width: 158px;
  height: 49px;
  border: transparent;
  border-radius: 32px;
  text-align: left;
  color: white;
  font-size: 12px;
  svg {
    width: 32px;
    color: white;
  }
  p {
    font-size: 14px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  @media (max-width: 576px) {
    width: 106px;
    font-size: 10px;
    p {
      font-size: 12px;
    }
    svg {
      width: 24px;
    }
  }
`;
